import { TextField, Button, Typography, Box } from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';

type EditVideoNameProps = {
  fileName: string;
  setFileName: Dispatch<SetStateAction<string>>;
  initialName: string;
};

export const EditVideoName = ({
  initialName,
  fileName,
  setFileName,
}: EditVideoNameProps) => {
  const [isEditingName, setIsEditingName] = useState(false);
  return (
    <div className="pb-4 flex flex-col">
      <Typography className="mb-1">Video title</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '36px',
          border: `solid 2px ${isEditingName ? '#C8CBEB' : '#B2B5BF'} `,
          borderRadius: '6px',
          paddingLeft: '12px',
        }}
      >
        <TextField
          value={fileName}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFileName(event.target.value);
          }}
          onBlur={() => setIsEditingName(false)}
          onFocus={() => setIsEditingName(true)}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              if (!fileName) {
                setFileName(initialName);
              }
              setIsEditingName(false);
              ev.preventDefault();
            }
          }}
          variant="standard"
          sx={{
            width: '100%',
            height: '19px',
            justifyContent: 'center',
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: '14px',
            },
          }}
        />
        <Button
          variant="text"
          className={'h-[22px]'}
          onClick={() => {
            setFileName(initialName);
            setIsEditingName(false);
          }}
        >
          Reset
        </Button>
      </Box>
    </div>
  );
};
